import { useText } from './loaders';
import { PreviewError, PreviewStatus } from './preview-state';

export function HtmlArtifactPreview({ sourceUrl, title }: { sourceUrl: string; title: string }) {
  const { data, error, loading } = useText(sourceUrl);

  if (loading) return <PreviewStatus>Loading {title}...</PreviewStatus>;
  if (error) return <PreviewError message={error.message} />;

  return (
    <iframe
      className="block size-full border-0 bg-white"
      data-testid="html-artifact-preview"
      referrerPolicy="no-referrer"
      sandbox="allow-scripts"
      srcDoc={data}
      title={title}
    />
  );
}
